import { defineComponent as _defineComponent } from 'vue';
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { isWorkflowInput } from "@/components/Workflow/constants";
import { iconClasses, statePlaceholders } from "@/composables/useInvocationGraph";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NodeInvocationText',
    props: {
        invocationStep: null
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, faCheckSquare, faSquare, FontAwesomeIcon, isWorkflowInput, iconClasses, statePlaceholders };
    }
});
